import React, { useState, lazy } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, QuoteIcon } from 'lucide-react';
const CustomerStories = () => {
  const [activeStory, setActiveStory] = useState(0);
  const stories = [{
    company: 'Montessori Academy',
    industry: 'Private Elementary School',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6VdDKdAcKT38BXoFFKcoLd/Elementary_5.webp',
    quote: "Our students and parents absolutely love SmartSoda. It's become an integral part of our healthy school environment. The kids are excited about choosing their own flavored waters, and parents appreciate our commitment to their children's health and the environment.",
    person: 'Sarah Martinez',
    title: 'Head of School',
    results: [{
      metric: '95%',
      description: 'Parent satisfaction rating'
    }, {
      metric: '18K+',
      description: 'Plastic bottles eliminated yearly'
    }, {
      metric: '100%',
      description: 'Student engagement with hydration'
    }]
  }, {
    company: 'Elite Sports Academy',
    industry: 'Youth Athletic Training Center',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qgAokndzYfyHqesVdDKHCw/University_8.webp',
    quote: 'SmartSoda has transformed our hydration program. Our young athletes stay properly hydrated with electrolyte options during training, and parents love the healthy choices available during competitions and events.',
    person: 'Coach Michael Chen',
    title: 'Athletic Director',
    results: [{
      metric: '40%',
      description: 'Increase in proper hydration'
    }, {
      metric: '92%',
      description: 'Parent approval rating'
    }, {
      metric: '22K',
      description: 'Single-use bottles eliminated'
    }]
  }, {
    company: 'Little Learners Preschool',
    industry: 'Early Childhood Education',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/whsXbJEPxLqJ9SzeVUzWBu/University_10.webp',
    quote: "We've implemented SmartSoda as part of our healthy habits curriculum. The children are learning about making good beverage choices while staying hydrated throughout the day. Parents consistently mention it as one of their favorite features of our program.",
    person: 'Jennifer Williams',
    title: 'Preschool Director',
    results: [{
      metric: '98%',
      description: 'Parent satisfaction'
    }, {
      metric: '12K',
      description: 'Juice boxes eliminated'
    }, {
      metric: '100%',
      description: 'Staff approval rating'
    }]
  }, {
    company: 'University Campus Dining',
    industry: 'Higher Education',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vHrZHg3hiwKfREoPhtMpdq/University_7.webp',
    quote: "SmartSoda has been a game-changer for our campus dining program. Students love the variety of healthy options, and we've significantly reduced our environmental impact while improving student satisfaction with our beverage offerings.",
    person: 'David Thompson',
    title: 'Director of Campus Dining Services',
    results: [{
      metric: '45%',
      description: 'Increase in student satisfaction'
    }, {
      metric: '85K',
      description: 'Plastic bottles eliminated annually'
    }, {
      metric: '4.8/5',
      description: 'Student rating'
    }]
  }];
  const nextStory = () => {
    setActiveStory(prev => (prev + 1) % stories.length);
  };
  const prevStory = () => {
    setActiveStory(prev => (prev - 1 + stories.length) % stories.length);
  };
  const story = stories[activeStory];
  return <section className="py-20 md:py-28 bg-gradient-to-b from-white to-blue-50" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-12 md:mb-16" data-id="element-145">
          <h2 className="text-2xl md:text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-146">
            Success Stories
          </h2>
          <p className="mt-4 text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-147">
            See how leading showrooms and retailers are transforming their
            customer experience and increasing sales with SmartSoda
          </p>
        </div>
        <div className="bg-white rounded-xl md:rounded-2xl shadow-lg md:shadow-xl overflow-hidden" data-id="element-148">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-149">
            {/* Image Section */}
            <div className="relative h-64 sm:h-72 lg:h-auto" data-id="element-150">
              <img src={story.image} alt={`${story.company} using SmartSoda in their luxury showroom setting`} className="absolute inset-0 w-full h-full object-cover" width="600" height="400" loading="lazy" decoding="async" data-id="element-151" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end" data-id="element-152">
                <div className="p-4 md:p-6" data-id="element-153">
                  <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-154">
                    {story.company}
                  </h3>
                  <p className="text-xs md:text-sm text-white/80" data-id="element-155">
                    {story.industry}
                  </p>
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="p-5 sm:p-6 md:p-8 lg:p-10 flex flex-col justify-between" data-id="element-156">
              <div data-id="element-157">
                <div className="mb-5 md:mb-6" data-id="element-158">
                  <QuoteIcon className="h-8 w-8 md:h-10 md:w-10 text-blue-400 mb-3 md:mb-4" data-id="element-159" />
                  <blockquote className="text-base md:text-lg lg:text-xl text-gray-700 italic mb-4 md:mb-6" data-id="element-160">
                    "{story.quote}"
                  </blockquote>
                  <div className="flex items-center" data-id="element-161">
                    <div data-id="element-162">
                      <p className="font-medium text-navy-950" data-id="element-163">
                        {story.person}
                      </p>
                      <p className="text-xs md:text-sm text-gray-500" data-id="element-164">
                        {story.title}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-165">
                  {story.results.map((result, index) => <div key={index} className="bg-blue-50 p-3 md:p-4 rounded-lg text-center" data-id="element-166">
                      <p className="text-xl md:text-2xl font-bold text-blue-600" data-id="element-167">
                        {result.metric}
                      </p>
                      <p className="text-xs md:text-sm text-gray-600" data-id="element-168">
                        {result.description}
                      </p>
                    </div>)}
                </div>
              </div>
              <div className="flex justify-between items-center" data-id="element-169">
                <div className="flex space-x-2" data-id="element-170">
                  {stories.map((_, index) => <button key={index} onClick={() => setActiveStory(index)} className={`h-2 w-2 md:h-2.5 md:w-2.5 rounded-full ${index === activeStory ? 'bg-blue-500' : 'bg-gray-300'}`} aria-label={`Go to story ${index + 1}`} data-id="element-171"></button>)}
                </div>
                <div className="flex space-x-2" data-id="element-172">
                  <button onClick={prevStory} className="p-1.5 md:p-2 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors" aria-label="Previous story" data-id="element-173">
                    <ArrowLeftIcon className="h-4 w-4 md:h-5 md:w-5 text-gray-600" data-id="element-174" />
                  </button>
                  <button onClick={nextStory} className="p-1.5 md:p-2 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors" aria-label="Next story" data-id="element-175">
                    <ArrowRightIcon className="h-4 w-4 md:h-5 md:w-5 text-gray-600" data-id="element-176" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 md:mt-14 text-center" data-id="element-177">
          <a href="#book-demo" className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 border border-transparent text-sm md:text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-178">
            Join Our Success Stories
          </a>
        </div>
      </div>
    </section>;
};
export default CustomerStories;